<template>
  <VDialog v-model="dialog" max-width="600">
    <VCard style="overflow: auto">
      <VBtn absolute style="right: 0" class="mt-1" icon @click="close">
        <VIcon>mdi-close</VIcon>
      </VBtn>

      <VCardTitle style="word-break: break-word"
        >{{ $t("nContract") }}{{ productDetails.contractNumber }}</VCardTitle
      >
      <VCardTitle style="word-break: break-word" class="pt-0">{{
        productDetails.productName
      }}</VCardTitle>
      <VCardText>
        <ValidationObserver ref="validationObserver" v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(save)">
            <VRow>
              <VCol md="6">
                <CustomInputText
                  :label="$t('name')"
                  :rules="{ required: true }"
                  v-model="incomeDialogFormData.lotName"
                  class="user_input no-margin"
                ></CustomInputText>
              </VCol>
              <VCol md="6">
                <CustomInputText
                  :label="$t('weight')"
                  only="number"
                  :rules="{
                    required: true,
                    max_value:
                      productDetails.acceptedCount - productDetails.receipt,
                  }"
                  v-model="incomeDialogFormData.count"
                  class="user_input no-margin"
                ></CustomInputText>
              </VCol>
            </VRow>
            <VRow>
              <VCol md="6">
                <CustomInputText
                  :label="$t('palletsNumber')"
                  only="number"
                  :rules="{
                    required: true,
                  }"
                  v-model="incomeDialogFormData.packageCount"
                  class="user_input no-margin"
                ></CustomInputText>
              </VCol>
              <VCol md="6">
                <CustomInputText
                  :label="$t('invoiceNumber')"
                  v-model="incomeDialogFormData.invoiceNo"
                  class="user_input no-margin"
                ></CustomInputText>
              </VCol>
            </VRow>

            <VRow>
              <VCol md="6">
                <CustomInputText
                  :label="$t('actNumber')"
                  v-model="incomeDialogFormData.actNo"
                  class="user_input no-margin"
                ></CustomInputText>
              </VCol>
              <VCol md="6">
                <CustomInputText
                  :label="$t('gtd')"
                  v-model="incomeDialogFormData.gtd"
                  class="user_input no-margin"
                ></CustomInputText>
              </VCol>
            </VRow>
            <VRow>
              <VCol md="6">
                <CustomDatePicker
                  clearable
                  v-model="incomeDialogFormData.date"
                  :label="$t('date')"
                  :name="$t('date')"
                  rules="required"
                  class="user_input data_item data_item_calendar"
                  icon="mdi-calendar-month small"
                ></CustomDatePicker>
              </VCol>
              <VCol md="6">
                <VueSelect
                  clearable
                  infinite
                  rules="required"
                  @item-resolved="setWarehouses"
                  @next-page-resolved="
                    (data) => setWarehouses([...warehouses, ...data])
                  "
                  :get-item-promise="
                    ({ text, page }) =>
                      getWarehouse({ name: text, page, limit: 15 })
                  "
                  :items="warehouses"
                  v-model="incomeDialogFormData.warehouseId"
                  item-text="name"
                  :label="$t('warehouse')"
                  class="product-select-in-modal no-margin"
                ></VueSelect>
              </VCol>
            </VRow>
            <VRow>
              <VCol md="6">
                <CustomDatePicker
                  clearable
                  v-model="incomeDialogFormData.productCreationDate"
                  :label="$t('manufactureDate')"
                  :name="$t('manufactureDate')"
                  class="user_input data_item data_item_calendar"
                  icon="mdi-calendar-month small"
                  rules="required"
                ></CustomDatePicker>
              </VCol>
              <VCol md="6">
                <CustomDatePicker
                  clearable
                  v-model="incomeDialogFormData.invoiceDate"
                  :label="$t('invoiceDate')"
                  :name="$t('invoiceDate')"
                  class="user_input data_item data_item_calendar"
                  icon="mdi-calendar-month small"
                  rules="required"
                ></CustomDatePicker>
              </VCol>
            </VRow>
            <VBtn class="mt-4" width="100%" color="primary" type="submit">{{
              $t("save")
            }}</VBtn>
          </form>
        </ValidationObserver>
      </VCardText>
    </VCard>
  </VDialog>
</template>

<script>
import { debounce, makerPagination } from "@/utils/pureFunctions.js";
import { dateFormat } from "@/utils/constants.js";
import VueSelect from "@/components/ui/vue-select/VueSelect";

const incomeDialogFormData = {
  lotName: null,
  contractItemId: null,
  count: null,
  packageCount: null,
  date: null,
  warehouseId: null,
  invoiceNo: null,
  invoiceDate: null,
  orderItemId: null,
  actNo: null,
  gtd: null,
  productCreationDate: null,
};
export default {
  data() {
    return {
      dialog: false,
      incomeDialogFormData: {
        ...incomeDialogFormData,
      },
      productDetails: {
        contractNumber: null,
        productName: null,
        acceptedCount: null,
        receipt: null,
      },
      warehouses: [],
    };
  },
  components: {
    VueSelect,
  },
  watch: {
    dialog(val) {
      if (!val) this.clear();
    },
  },
  methods: {
    clear() {
      this.incomeDialogFormData = { ...incomeDialogFormData };
      this.dialog = false;
      this.$refs.validationObserver.reset();
    },
    async getWarehouse(params) {
      this.showLoading();
      try {
        const {
          data: { data, total },
        } = await this.$http.get("warehouse/own-list", {
          params,
        });
        this.warehouses = data;
        return {
          data,
          lastPage: makerPagination({ limit: params.limit, total }).lastPage,
        };
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    async save() {
      this.showLoading();
      try {
        await this.$http.post("partition/add", this.incomeDialogFormData);
        this.$emit("updateTableData");
        this.setSuccess({ text: this.$t("successfullySaved") });
        this.clear();
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    onChangeHandler: debounce(function () {
      let filter = { ...this.incomeDialogFormData };
      if (filter.fromDate)
        filter.fromDate = window.moment(filter.fromDate).format(dateFormat);
      if (filter.toDate)
        filter.toDate = window.moment(filter.toDate).format(dateFormat);
      this.getContractsByFilter();
    }, 500),
    open(contractNumber, productName, acceptedCount, receipt, id) {
      this.dialog = true;
      this.productDetails = {
        contractNumber,
        productName,
        acceptedCount,
        receipt,
      };
      this.incomeDialogFormData.contractItemId = id;
    },
    close() {
      this.dialog = false;
    },
    setWarehouses(warehouses) {
      this.warehouses = warehouses;
    },
  },
};
</script>
